// frontend/klaes-app/src/components/FilmFavs/components/UserRatingsPopup.jsx
import { FiX } from 'react-icons/fi';
import { BatteryIndicator } from './BatteryIndicator';
import { styles } from '../styles';

export const UserRatingsPopup = ({ ratings, users, onClose }) => {
  return (
    <div className={styles.modalUserRatingsPopup}>
      <div className={styles.modalUserRatingsHeader}>
        <span>Alle Bewertungen</span>
        <FiX onClick={onClose} />
      </div>
      <div className={styles.modalUserRatingsList}>
        {Object.entries(ratings).map(([userName, rating]) => {
          const user = users[userName] || { avatar_emoji: '👤', tagname: userName };
          return (
            <div key={userName} className={styles.modalUserRatingItem}>
              <div className={styles.modalUserInfo}>
                <span className={styles.modalUserAvatar}>{user.avatar_emoji || '👤'}</span>
                <span className={styles.modalUserName}>{user.tagname || userName}</span>
              </div>
              <BatteryIndicator rating={rating} />
            </div>
          );
        })}
      </div>
    </div>
  );
};